import { SET_ALERT } from './../actionTypes'

const initialState = {
  open: false,
  type: null,
  message: null,
  duration: null,
}

export const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALERT:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
